export const LOAD_CONTENT = 'hg/cancel/LOAD_CONTENT';
export const DISCONNECT_CUSTOMER = 'hg/cancel/DISCONNECT_CUSTOMER';
export const DL_PAGE_LOADED = 'mp/movers/cancel/DL_PAGE_LOADED';



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/cancel/cancel.js
 **/